<mat-form-field [appearance]="appearance">
  <mat-label>{{label}}</mat-label>
  <mat-icon matPrefix color="primary">language</mat-icon>
  <mat-select [formControl]="control" (selectionChange)="languageChange.emit($event.value)">
    @for (language of $languages | async; track language.id) {
      <mat-option [value]="language.name">
        {{ language.localName }}
      </mat-option>
    }
  </mat-select>
</mat-form-field>

